import { render } from "./ClassBookingView.vue?vue&type=template&id=d201d2ca&scoped=true"
import script from "./ClassBookingView.vue?vue&type=script&lang=js"
export * from "./ClassBookingView.vue?vue&type=script&lang=js"

import "./ClassBookingView.vue?vue&type=style&index=0&id=d201d2ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d201d2ca"]])

export default __exports__